import React, { PureComponent } from "react";

// import components
import BranchSingle from "./BranchSingle";

// import local branch data
import { nwMontanaBranchData } from "../data/branchData";

class App extends PureComponent {
  render() {
    const path = "/nw-montana";
    return <BranchSingle key={path} path={path} branch={nwMontanaBranchData} />;
  }
}

export default App;
